import environment, { Environment } from "./base";

const baseApi = "https://api.hub.ucc-stg.vodafone.com";
const legacyBaseApi = "https://api.connectedcomms.click";
const env = environment(baseApi, legacyBaseApi);

const developmentEnv: Environment = {
  ...env,
  api: {
    ...env.api,
  },
  legacyApi: {
    ...env.legacyApi,
  },
  portalUrl: "https://hub.ucc-stg.vodafone.com",
  isProduction: false,
  isDevelopment: false,
  isStaging: true,
};

export default developmentEnv;
